import { Injectable } from '@angular/core';
import {
  CreateVenderProductOrderInput,
  VenderProductInfo,
  VenderProductNotifyInfo,
  VenderProductOrderDetailInfo,
  VenderProductOrderInfo,
  VenderProductOrderStatus,
} from '@mommy/models/vender-product.model';
import { VenderApi } from './api-vender';

// 百寶袋（vender 商品）API — 台灣醫智（商家版）個案端
// request envelope: { data: {...} }；response: { returnCode, message, data }
@Injectable({
  providedIn: 'root',
})
export class VenderProductService {
  constructor(public api: VenderApi) {}

  // 取得商品列表（只回 PUBLISHED；keyword 模糊比對商品名稱）
  // team_id = App 團隊 ID，後端自動解析對應商家
  async show_product_list(data: {
    team_id: number;
    keyword?: string;
  }): Promise<VenderProductInfo[]> {
    const result = await this.api.post('appv2/venderproduct/show_product_list', { data });
    return this.extractData(result)?.data || [];
  }

  // 取得商品詳細（PUBLISHED / SUSPENDED；含 can_order）
  async show_product_detail(data: {
    team_id: number;
    product_id: number;
  }): Promise<VenderProductInfo> {
    const result = await this.api.post('appv2/venderproduct/show_product_detail', { data });
    return this.extractData(result)?.data;
  }

  // 個案登記訂單（初始狀態 NEW；member_id 由 token 推得）
  async create_order(data: CreateVenderProductOrderInput): Promise<{ order_id: number }> {
    const result = await this.api.post('appv2/venderproductorder/create_order', { data });
    return this.extractData(result)?.data;
  }

  // 取得我的訂單列表（token 本人；created_at 降冪；含商品名稱/規格/數量快照與商品圖）
  async show_order_list(data?: {
    team_id?: number;
    order_status?: VenderProductOrderStatus;
  }): Promise<VenderProductOrderInfo[]> {
    const result = await this.api.post('appv2/venderproductorder/show_order_list', {
      data: data || {},
    });
    return this.extractData(result)?.data || [];
  }

  // 取得訂單詳細（含價格快照明細）
  async show_order_detail(data: { order_id: number }): Promise<VenderProductOrderDetailInfo> {
    const result = await this.api.post('appv2/venderproductorder/show_order_detail', { data });
    return this.extractData(result)?.data;
  }

  // 個案取消訂單（cancel_remark 必填；僅 NEW / READY_FOR_PICKUP 可取消）
  async cancel_order(data: { order_id: number; cancel_remark: string }): Promise<void> {
    const result = await this.api.post('appv2/venderproductorder/cancel_order', { data });
    this.extractData(result);
  }

  // 取得指定訂單的通知記錄（notified_at 降冪）
  async show_notification_list(data: { order_id: number }): Promise<VenderProductNotifyInfo[]> {
    const result = await this.api.post('appv2/venderproductnotify/show_notification_list', { data });
    return this.extractData(result)?.data || [];
  }

  private extractData(res: any) {
    console.log('VenderProductService response', res);
    if (res?.returnCode === 'OK') {
      return res;
    } else {
      const error: any = new Error(res?.message || 'API 發生錯誤');
      error.api_error = true;
      throw error;
    }
  }
}
